export const goToLessonQuestionIndex = (dispatch, index) =>
  dispatch({ type: "LESSON_QUESTION_INDEX_CHANGED", index });
